import { IProposalDetails } from '../types';

export const getIssuePolicyLabel = (isCorrection?: boolean) =>
  isCorrection ? 'Update Policy' : 'Issue Policy';

export function buildClausePreviewDataFromPd(
  generalData: IProposalDetails,
  proposalId?: string
): any {
  const lineExternalCode = generalData?.line?.code;

  const lineId = generalData?.line?.id;

  const planId = generalData?.plan?.id;

  const currency = generalData?.policyCurrency?.id;

  const ClauseEditable = generalData?.plan?.isEditableClause;

  return {
    Id: proposalId,
    Status: generalData?.status,
    LineId: {
      Id: lineId,
      ExternalCode: String(lineExternalCode ?? '')
    },
    PlanID: {
      Id: planId,
      ClauseEditable: ClauseEditable
    },
    PolicyCurrency: {
      Code: currency,
      Symbol: currency
    },
    PolicyEffectiveDate: generalData?.policyEffectiveDate,
    PolicyExpiryDate: generalData?.policyExpiryDate
  };
}
